export const AUCTION_EVENT_TYPES = {
    SUCCESSFUL: "successful",
    CREATED: "created",
    CANCELLED: "cancelled",
    TRANSFER: "transfer",
    APPROVE: "approve",
    BID_ENTERED: "bid_entered",
    BID_WITHDRAWN: "bid_withdrawn",
    OFFER_ENTERED: "offer_entered",
    CUSTOM: "custom",
};
export const NULL_ACCOUNT = "0x0000000000000000000000000000000000000000";
